const FlashAutoCloseHook = {
  mounted() {
    this.autoCloseTimer = null;

    // Check if this flash should auto-close
    const shouldAutoClose = this.el.dataset.autoClose === "true";
    
    if (shouldAutoClose) {
      // Get the flash kind from the element ID (e.g., "flash-info" -> "info")
      const flashKind = this.el.id.replace("flash-", "");
      
      // Auto-close after 8 seconds
      this.autoCloseTimer = setTimeout(() => {
        this.autoCloseTimer = null;

        // Trigger the same hide action as clicking the flash
        this.pushEvent("lv:clear-flash", { key: flashKind });
        this.el.style.display = "none";
      }, 8000);
    }
  },

  destroyed() {
    if (this.autoCloseTimer !== null) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }
};

export default FlashAutoCloseHook;
